const Label = ({label}) => {
    return (
        <p className="text-black p-0 m-0" style={{ fontWeight: 500, fontSize: '17.5px'}}>{label}</p>
    )
}

export default Label